<script setup>
import { useRoute } from "vue-router"
import { userProfile, getSchoolStaff } from "@/services/ApiUrlService"
import { useAuthStore } from "@/stores/authStore"
import { router } from "@/plugins/1.router"

definePage({
  meta: {
    layout: "blank",
    public: true,
  },
})

const route = useRoute()
const authStore = useAuthStore()

const email = ref(route.query.email)
const token = ref(route.query.token)
const survey = ref(route.query.survey)
const admin = ref(route.query.isAdmin)
const campaign = ref(import.meta.env.VITE_CAMPAIGN === 'true')

const getProfileUser = async () => {
  try {
    const { data, response } = await useApi(`${userProfile}/${email.value}`)

    if (data.value?.schoolStaffId) {
      getProfile(data.value?.schoolStaffId)
    }

    if (survey) {
      authStore.setSurveyRoute(survey)
    }

    authStore.loginByRoute(data.value, admin.value)
  } catch (error) {
    console.log(error)
  }
}

const getProfile = async (schoolStaffId) => {
  try {
    const { data } = await useApi(`${getSchoolStaff}/${schoolStaffId}`)

    useAuthStore().setProfileUser(data.value)
  } catch (error) {
    Toast.fire({
      icon: "error",
      title: $gettext("Quelque chose s'est mal passé"),
    })
  }
}
// callback?token=08a221c7-2ff4-4ff0-9b8a-43c4e1a4e7b5&email=anne.courtois@noschool.fr&survey=861
// localhost:8000/callback?token=74fe6dc0-423d-41ca-8201-06d5c416ef6b&email=quang.bui2@silkwires-dev.com&survey=861
watch(
  [() => email.value, () => token.value],
  async ([newEmail, newToken]) => {
    if (newEmail && newToken) {
      useCookie("accessToken").value = newToken
      useCookie("email").value = newEmail
      await getProfileUser()
    }
  },
  { immediate: true }
)
</script>
<template>
  <Waiting :show="true" />
</template>
<style lang="scss" scoped></style>
